import { iotDevicesTypes } from './iotDevicesTypes';

const {
  GET_IOT_DEVICES,
  GET_IOT_DEVICE,
  CREATE_IOT_DEVICE,
  MOD_IOT_DEVICE,
  SET_IOT_DEVICE_SELECTED,
  RESET_IOT_DEVICE_SELECTED,
  ADD_IOT_DEVICE_MODE,
  EDIT_IOT_DEVICE_MODE,
  GET_ASSIGN_HISTORY,
  GET_IOT_DEVICES_BY_ACCOUNT,
  CLEAR_ACCOUNT_IOT_DEVICES,
  SET_IOT_DEVICES_FILTERS,
  RESTORE_INITIAL,
} = iotDevicesTypes;

const INITIAL_STATE = {
  iotDevicesList: [],
  accountIotDevices: [],
  iotDeviceSelected: null,
  assignHistory: [],
  addMode: false,
  station: {},
};

export const iotDevicesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_IOT_DEVICES:
      return { ...state, iotDevicesList: payload };

    case CLEAR_ACCOUNT_IOT_DEVICES:
      return { ...state, accountIotDevices: [] };

    case GET_IOT_DEVICES_BY_ACCOUNT:
      return { ...state, accountIotDevices: payload };

    case GET_IOT_DEVICE:
      return { ...state, iotDeviceSelected: payload };

    case CREATE_IOT_DEVICE:
      return { ...state, iotDevicesList: [payload, ...state.iotDevicesList] };

    case MOD_IOT_DEVICE:
      return {
        ...state,
        iotDevicesList: state.iotDevicesList.map(d => d.id === payload.id ? { ...d, ...payload } : d),
        iotDeviceSelected: state.iotDeviceSelected?.id === payload.id ? { ...state.iotDeviceSelected, ...payload } : state.iotDeviceSelected,
      };

    case SET_IOT_DEVICE_SELECTED:
      return { ...state, iotDeviceSelected: payload };

    case RESET_IOT_DEVICE_SELECTED:
      return { ...state, iotDeviceSelected: null, assignHistory: [] };

    case ADD_IOT_DEVICE_MODE:
      return { ...state, addMode: true };

    case EDIT_IOT_DEVICE_MODE:
      return { ...state, addMode: false };

    case GET_ASSIGN_HISTORY:
      return { ...state, assignHistory: payload };

    case SET_IOT_DEVICES_FILTERS:
      return { ...state, [payload.key]: payload.data };

    case RESTORE_INITIAL:
      return INITIAL_STATE;

    default:
      return state;
  }
};
